import React from 'react';

const PlayIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 md:w-6 md:h-6">
        <circle cx="12" cy="12" r="11.5" stroke="currentColor" />
        <path d="M9.5 16V8L16.5 12L9.5 16Z" fill="currentColor" />
    </svg>
);

export default PlayIcon;
